export function slug(link) {
  if (link.startsWith("/")) return link;
  else return `/${link}`;
}
